import type * as Types from '../../../../../shared/generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetAccessibleClientGroupListQueryVariables = Types.Exact<{
  input: Types.GetAccessibleClientGroupListInput;
}>;

export type GetAccessibleClientGroupListQuery = {
  __typename?: 'Query';
  getAccessibleClientGroupList: {
    __typename?: 'GetAccessibleClientGroupListResponse';
    items: Array<{
      __typename?: 'GetAccessibleClientGroupListResponseClientGroup';
      name: string;
      uuid: string;
    }>;
    pagination?: {
      __typename?: 'PaginationResponse';
      pageNumber: number;
      pageSize: number;
      total: number;
      totalPage: number;
    } | null;
  };
};

export const GetAccessibleClientGroupListDocument = gql`
  query GetAccessibleClientGroupList(
    $input: GetAccessibleClientGroupListInput!
  ) {
    getAccessibleClientGroupList(input: $input) {
      items {
        name
        uuid
      }
      pagination {
        pageNumber
        pageSize
        total
        totalPage
      }
    }
  }
`;
export function useGetAccessibleClientGroupListQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAccessibleClientGroupListQuery,
    GetAccessibleClientGroupListQueryVariables
  > &
    (
      | {
          variables: GetAccessibleClientGroupListQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAccessibleClientGroupListQuery,
    GetAccessibleClientGroupListQueryVariables
  >(GetAccessibleClientGroupListDocument, options);
}
export function useGetAccessibleClientGroupListLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAccessibleClientGroupListQuery,
    GetAccessibleClientGroupListQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAccessibleClientGroupListQuery,
    GetAccessibleClientGroupListQueryVariables
  >(GetAccessibleClientGroupListDocument, options);
}
export function useGetAccessibleClientGroupListSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        GetAccessibleClientGroupListQuery,
        GetAccessibleClientGroupListQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    GetAccessibleClientGroupListQuery,
    GetAccessibleClientGroupListQueryVariables
  >(GetAccessibleClientGroupListDocument, options);
}
export type GetAccessibleClientGroupListQueryHookResult = ReturnType<
  typeof useGetAccessibleClientGroupListQuery
>;
export type GetAccessibleClientGroupListLazyQueryHookResult = ReturnType<
  typeof useGetAccessibleClientGroupListLazyQuery
>;
export type GetAccessibleClientGroupListSuspenseQueryHookResult = ReturnType<
  typeof useGetAccessibleClientGroupListSuspenseQuery
>;
export type GetAccessibleClientGroupListQueryResult = Apollo.QueryResult<
  GetAccessibleClientGroupListQuery,
  GetAccessibleClientGroupListQueryVariables
>;
export function refetchGetAccessibleClientGroupListQuery(
  variables: GetAccessibleClientGroupListQueryVariables,
) {
  return { query: GetAccessibleClientGroupListDocument, variables: variables };
}
